import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TodayUpdates from './components/TodayUpdates';
import NewRelease from './components/NewRelease';
import CinemaSync from './components/CinemaSync';
import HotMovies from './components/HotMovies';
import LibraryFilter from './components/LibraryFilter';
import NewsSection from './components/NewsSection';
import WatchGuide from './components/WatchGuide';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TodayUpdates />
        <NewRelease />
        <CinemaSync />
        <HotMovies />
        <LibraryFilter />
        <NewsSection />
        <WatchGuide />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}